function cartSetRemove(el){
  var keys = $(el).attr('data-key').split(",");
  
  var formData = new FormData();
  
  if(document.querySelector(`#CartDrawer`)){
    const sectionId = theme.utils.sectionId(document.querySelector(`#CartDrawer`));
    formData.append('sections', sectionId);
  }
  
  $.each(keys,function(n,key){
    if(key){
      formData.append("updates["+ key +"]", 0);
    }
  });

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(async (parsedState) => {
    if(document.querySelector(`#CartDrawer`) == null){
      location.reload();
    }
    const cartJson = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig()})).json();
    cartJson['sections'] = parsedState['sections'];
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  });
};

function updateGiftProduct(id,quntity){
  var formData = new FormData();
  const sectionId = theme.utils.sectionId(document.querySelector(`#CartDrawer`));
  formData.append('sections', sectionId);
  formData.append("updates["+ id +"]", quntity);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(async (parsedState) => {
    const cartJson = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig()})).json();
    cartJson['sections'] = parsedState['sections'];
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  });
}

  function formatAmount(amount) {
  
    // 将字符串转换为浮点数
    // if(typeof amount === 'string'){
    //   amount = parseFloat(amount);
    // }

    // 除以100
    const result = amount / 100;

    // 保留两位小数
    const formattedResult = result.toFixed(2);
  
    // 创建一个货币格式化器
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active,
      currencyDisplay: 'symbol'
    });

    // 格式化金额
    const formattedAmount = formatter.format(formattedResult);

    // 将符号移动到金额前面
    const adjustedAmount = formattedAmount.replace(/^\s*([^\d]*)(.*)$/, '$1$2');

    return adjustedAmount;
  }

  //产品详情页，点击评分滚动到评论
  $(document).on('click', '.scroll-to-anchor', function (e) {
    const targetId = $(this).attr('href');
    const $target = $(targetId);
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - 90
      }, 500);
    }
  });

  function customLetters(font){
    let letter = $('input[name="properties[Customize Your Letters]"]');
    let text = letter.val();
    letter.attr('maxlength',font);
    letter.val(text.substring(0,font));
  }

  if($('input[name="Select the number of letters"]:checked').val()){
    customLetters($('input[name="Select the number of letters"]:checked').val());
  }

  $(document).on('change', 'input[name="Select the number of letters"]', function() {
    customLetters($(this).val());
  });
